import { css, styled } from "@mui/material";

import { getColor } from "@hooks/useColors";

export const ServiceListSection = styled("div")(
  ({ theme }) => css`
    font-size: 10px;
    font-family: "Roboto Mono", monospace;
    text-align: justify;
    color: ${getColor(x => x.tokens.text["sub-600"], theme)};
  `,
);

export const ServiceTitle = styled("span")(
  ({ theme }) => css`
    color: ${getColor(x => x.tokens.text["sub-600"], theme)};
  `,
);
